<script>
    import { createEventDispatcher } from "svelte";
    import FormattedDate from "./FormattedDate.svelte";

    export let post;

    const password = localStorage.getItem("#" + post.id);
    const dispatch = createEventDispatcher();
    let error_message = "";

    async function deletePost() {
        const res = await fetch(
            "/api/comments/" +
                post.id +
                "?password=" +
                password,
            {
                method: "DELETE",
                body: JSON.stringify({ password: password }),
            },
        );

        if (res.ok) {
            localStorage.removeItem("#" + post.id);
            dispatch("update");
        } else {
            const json = await res.json();
            error_message = JSON.stringify(json);
        }
    }
</script>

<div class="mb-4" id={post.id}>
    <div class="discordia-preample mb-1">
        <span class="text-cyan-500">
            {post.author}
        </span>
        <FormattedDate dateString={post.created_at} />
        <span>No.{post.id}</span>
        {#if password}
            <button class="text-red-500 cursor-pointer" on:click={deletePost}>delete</button>
        {/if}
        <span>
            {#if post.isRepliedBy}
                {#each post.isRepliedBy as reply}
                    <a href={"#" + post.id}> {">>" + reply} </a>
                {/each}
            {/if}
            <span /></span
        >
    </div>
    <div class="mb-2">
        <p class="max-w-prose whitespace-pre-wrap">
            {post.content}
        </p>
    </div>
</div>
